export default "__VITE_ASSET__BkUo74sG__"